import Vue from 'vue'
import { isMultiSheet } from '@/config/multiSheetModules'
import ExportScopeDialog from '@/components/ExportScopeDialog/index.vue'

// 全局导出弹窗实例（单例）
let dialogInstance = null

function showExportDialog(moduleName, exportFn, exportFileName) {
  if (!dialogInstance) {
    const DialogCtor = Vue.extend(ExportScopeDialog)
    dialogInstance = new DialogCtor()
    dialogInstance.$mount()
    document.body.appendChild(dialogInstance.$el)
  }
  dialogInstance.open(moduleName, exportFn, exportFileName)
}

Vue.directive('contextmenu', {
  bind(el, binding) {
    if (!binding.value) return

    const { module, exportApi, exportFileName } = binding.value

    // 创建右键菜单 DOM
    const menu = document.createElement('div')
    menu.className = 'context-menu'
    menu.style.cssText = `
      position: fixed; z-index: 9999; background: #fff; border: 1px solid #e4e7ed;
      border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,0.1); padding: 6px 0;
      display: none; min-width: 140px;
    `
    menu.innerHTML = `
      <div class="context-menu-item" data-action="export" style="padding:8px 16px;cursor:pointer;font-size:13px;color:#606266;">
        <i class="el-icon-download"></i> 导出数据
      </div>
    `
    document.body.appendChild(menu)

    // 右键事件
    el.addEventListener('contextmenu', (e) => {
      e.preventDefault()
      menu.style.display = 'block'
      menu.style.left = e.clientX + 'px'
      menu.style.top = e.clientY + 'px'

      // 权限检查
      const menuItem = menu.querySelector('[data-action="export"]')
      if (binding.value.hasExportPermission === false) {
        menuItem.style.display = 'none'
      } else {
        menuItem.style.display = ''
      }
    })

    // 点击菜单项
    menu.addEventListener('click', (e) => {
      const target = e.target.closest('[data-action]')
      if (!target) return
      menu.style.display = 'none'

      const action = target.dataset.action
      if (action === 'export') {
        if (isMultiSheet(module)) {
          // 多层：弹窗选择
          showExportDialog(module, exportApi, exportFileName || '导出数据')
        } else {
          // 单层：直接导出
          if (exportApi) exportApi({ scope: 'header' })
        }
      }
    })

    // 点击其他地方关闭
    document.addEventListener('click', () => { menu.style.display = 'none' })

    // 存储引用用于 unbind
    el._contextMenu = menu
  },
  unbind(el) {
    if (el._contextMenu) {
      el._contextMenu.remove()
      delete el._contextMenu
    }
  }
})
